import actions from '../permissions/permissionsActions'
import mutations from '../permissions/permissionsMutations'

export default {
  namespaced: true,
  actions,
  mutations
}